import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
var defaults = {
  firstName: '',
  lastName: '',
  email: '',
  fullName: '',
  name: '',
  userId: null
};

var UserProfile = /*#__PURE__*/function (_Record) {
  _inherits(UserProfile, _Record);

  function UserProfile() {
    _classCallCheck(this, UserProfile);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserProfile).apply(this, arguments));
  }

  _createClass(UserProfile, null, [{
    key: "from",
    value: function from(json) {
      return new UserProfile(json);
    }
  }, {
    key: "fromUser",
    value: function fromUser(json) {
      return new UserProfile(Object.assign({
        firstName: json.first_name,
        lastName: json.last_name,
        userId: json.user_id
      }, json));
    }
  }]);

  return UserProfile;
}(Record(defaults));

export { UserProfile as default };